<template>
  <div
    class="main-content"
    :class="{
      'main-content--left-sidebar-present': leftSidebar,
      'main-content--right-sidebar-present': rightSidebar
    }"
  >
    <transition name="fade">
      <img v-if="backgroundAssetType === 'image' && backgroundImage" class="main-content__background" :key="backgroundImage" :src="`${$store.state.assetsPath}${backgroundImage}`">
      <video
        v-if="backgroundAssetType === 'video' && backgroundImage"
        :key="backgroundImage"
        class="main-content__background"
        :src="`${$store.state.assetsPath + backgroundImage}`"
        autoplay
        muted
        loop
      ></video>
    </transition>
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: ['backgroundImage', 'left-sidebar', 'right-sidebar'],

  computed: {
    backgroundAssetType () {
      if (this.backgroundImage && this.backgroundImage.split('.').pop() === 'mp4') {
        return 'video'
      } else {
        return 'image'
      }
    }
  }
}
</script>
<style lang="scss">
@import "@/styles/_variables.scss";
@import "node_modules/tiny-slider/src/tiny-slider";
  .main-content {
    width: 192rem;
    height: 100rem;
    position: absolute;
    top: 0;
    left: 0;

    &__background {
    height: 100%;
    left: 0;
    object-fit: cover;
    position: absolute;
    top: 0;
    width: 100%;
  }

    &--right-sidebar-present {
      width: 152rem;
    }

    &--left-sidebar-present {
      width: 152rem;
    }

    .main--right-sidebar-present.main--left-sidebar-present {
      width: 152rem;
    }
  }
</style>